import { render, staticRenderFns } from "./CollectStudy.vue?vue&type=template&id=75bbaca3&scoped=true"
import script from "./CollectStudy.vue?vue&type=script&lang=ts"
export * from "./CollectStudy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bbaca3",
  null
  
)

export default component.exports